<template>
  <div @click="onHourClick" :class="className"> 
    {{value}}
    <div class="dots">
        <div v-if="hasAdio"  class="has-adio-h"></div>
        <div v-if="hasVideo" class="has-video-h"></div>
        <div v-if="hasWeather" class="has-weather-h"></div>
        <div v-if="hasAudio" class="has-audio-h"></div>
        <div v-if="hasNoise" class="has-noise-h"></div>
    </div>
   </div>
</template>

<style>
    .hour-value{
        font-size: 17px;
        padding: 4px;
        padding-left: 0px;
        cursor: default;
        text-align: center;
    }
    .hour-value:hover{
        background-color: #525E64;
    }
    .selected{
        background-color: #22313F;
    }
    .dots {
        width: 30px;
        float: right;
    }
    .has-audio-h{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float: right;
        background-color: #E7505A;
    }
    .has-noise-h{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float: right;
        background-color: #4C87B9;
    }
    .has-weather-h{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float: right;
        background-color:#13CE66;
    }
    .has-video-h{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float: right;
        background-color:#F7BA2A;
    }
    .has-adio-h{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float: right;
        background-color:#daff00;
    }
</style>

<script>
import {setSelectedHour} from '../../store/actions';
import { mapGetters } from 'vuex'
import * as utils from '../../common/utils'

export default {
    props:['hour'],
     data(){
        return{
            hasAudio: false,
            hasNoise: false,
            hasWeather: false,
            hasVideo: false,
            hasAdio:false,
            enabled: false,
        }
    },
	computed:{
		...mapGetters([
            'getSelectedHour',
            'getSelectedDay',
            'getSelectedDayHours',
        ]),
		value: function(){
            var searchableFormat = this.getSelectedDay.year+'-'+utils.doubleDigit(this.getSelectedDay.month+1)+'-'+utils.doubleDigit(this.getSelectedDay.day)+'-'+utils.doubleDigit(this.hour.split('-')[3]);
            if(this.getSelectedDayHours[searchableFormat] ) { 
                this.hasNoise = this.getSelectedDayHours[searchableFormat].noise;
                this.hasAudio = this.getSelectedDayHours[searchableFormat].audio;
                this.hasWeather = this.getSelectedDayHours[searchableFormat].weather;
                this.hasVideo = this.getSelectedDayHours[searchableFormat].video;
                this.hasAdio = this.getSelectedDayHours[searchableFormat].adio;
            }
            else {
                this.hasNoise = false;
                this.hasAudio = false;
                this.hasWeather = false;
                this.hasVideo = false;
                this.hasAdio = false;
            }
			return /*this.getSelectedDay.day+'.'+this.getSelectedDay.month+'.'+this.getSelectedDay.year + ' - '+*/this.hour.split('-')[3]+':00';
		},
		className:function(){
			var className = 'hour-value';
			if(this.getSelectedHour.trim() == this.hour.split('-')[3]){
				className+= ' selected';   
			}
			return className;
		}
	},
	methods: {
		onHourClick: function(){
            setSelectedHour(this.$store, this.hour.split('-')[3]);
            if(this.$route.fullPath != '/')
                this.$router.push('/');
		}
	}
}
</script>





// WEBPACK FOOTER //
// CalendarHour.vue?8f15fd8e